import axios from "../plugins/axios";

const baseUrl = "/web_api/v1/task_list_template";

export default {
  all() {
    return axios.get(`${baseUrl}`).then((response) => response.data);
  },

  get(taskListId) {
    return axios.get(`${baseUrl}/${taskListId}`).then((response) => response.data);
  },

  save(data) {
    return axios.post(`${baseUrl}`, data).then((response) => response.data);
  },

  update(taskListId, data) {
    return axios.patch(`${baseUrl}/${taskListId}`, data).then((response) => response.data);
  },
};
